import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { TourGuideState, GetTourGuidesParams } from "@/types/admin/tour-guide-type";
import { tourGuideService } from "@/services/system-admin/admin-data.service";

const initialState: TourGuideState = {
  tourGuides: [],
  loading: false,
  error: null,
  totalCount: 0,
  currentPage: 1,
  pageSize: 20,
};

export const fetchTourGuides = createAsyncThunk(
  "tourGuides/fetchTourGuides",
  async (params: GetTourGuidesParams) => {
    return await tourGuideService.getTourGuides(params);
  }
);

const tourGuideSlice = createSlice({
  name: "tourGuides",
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTourGuides.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
    .addCase(fetchTourGuides.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.tourGuides = payload.items ?? payload ?? [];
        state.totalCount = payload.totalCount ?? state.tourGuides.length;
        state.currentPage = payload.page ?? payload.currentPage ?? state.currentPage;
        state.pageSize = payload.pageSize ?? state.pageSize;
      })
      .addCase(fetchTourGuides.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch tour guides";
      });
  },
});

export const { clearError } = tourGuideSlice.actions;
export default tourGuideSlice.reducer;